import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=5e11e3fb"
import script from "./Primary.vue?vue&type=script&setup=true&lang=js"
export * from "./Primary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Primary.vue?vue&type=style&index=0&id=5e11e3fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports